import React from "react";

import { ResultAsset, type ResultAssetProps } from "./ResultAsset";
import { ResultButton } from "./ResultButton";
import { resultSubtitleVariants, resultVariants, type ResultVariantsProps } from "./Result.styles";
import { ResultEmpty } from "./ResultEmpty";

export type ResultProps = ResultAssetProps &
  ResultVariantsProps & {
    title?: React.ReactNode;
    subTitle?: React.ReactNode;
    children?: React.ReactNode;
    showGoHome?: boolean;
  };

/**
 * Se utiliza para mostrar información de resultados o de errores.
 * Tipicamente "no hubo resultados para esa búsqueda"
 *
 *  ```
 *
 *  import { Result } from "@/components";
 *
 *  ```
 *  ```
 *  <Result
 *    subTitle="Selecciona otro año o mes y vuelve a intentarlo."
 *    title="No puedes cargar una liquidación para este período"
 *  />
 *  ```
 */
export const Result = ({
  title,
  subTitle,
  showGoHome,
  status,
  children,
  size,
  icon = "info",
}: ResultProps) => {
  const handleNavigate = () => {
    window.location.href = "/";
  };

  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-3 pb-4">
      <ResultAsset icon={icon} size={size} status={status} />
      <div className="flex flex-col items-center gap-1">
        {title && <h2 className={resultVariants({ size })}>{title}</h2>}
        {subTitle && <h3 className={resultSubtitleVariants({ size })}>{subTitle}</h3>}
      </div>
      {children && <div>{children}</div>}
      {showGoHome && <ResultButton onClick={handleNavigate}>Volver al inicio</ResultButton>}
    </div>
  );
};

Result.Empty = ResultEmpty;
